import {
  Box,
  Button,
  Card,
  CardContent, Checkbox, CircularProgress,
  Container,
  FormControl, FormControlLabel, FormGroup, Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useFormik } from "formik";
import { getErrorMessage, isError } from "libs/utils/form";
import HttpClient from "libs/utils/HttpClient";
import queryString from "query-string";
import { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { clearLoginAsyncState, Register } from "redux/modules/authSlice";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: 1,
    height: "100%",
    padding: 10,
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(./assets/images/bg-login.png), linear-gradient(to bottom left, ${theme.palette.primary.main}, #00c2cb 45%, ${theme.palette.secondary.main})`,

    objectFit: "cover",
    backgroundSize: "cover",
    backgroundPosition: "50% 50%",
    backgroundRepeat: "no-repeat",
    backgroundBlendMode: "screen",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 3px 17px 0 rgba(44, 40, 40, 0.11)",

    paddingLeft: 25,
    paddingRight: 25,
    paddingTop: 25,
    paddingButton: 45,
    flex: 1,
    borderRadius: 10,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  logo: {
    display: "flex",
    alignSelf: "center",
    width: 300,
    margin: theme.spacing(4),
  },
  title: {
    fontSize: 55,
    color: "#003b5c",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: 50,
    backgroundColor: "#11cdef",
    alignSelf: "center",
  },
  offlineLogin: {
    alignSelf: "center",
  },
  loading: {
    marginRight: theme.spacing(1),
  },
  line: {
    marginTop: 8,
    height: 3,
    width: 50,
    backgroundColor: "#11cdef",
  },
}));

export default function RegisterPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const { search } = useLocation();
  const queryParams = queryString.parse(search);
  const [roleData, setRole_Data] = useState([]);
  const [checkBox, setCheckbox] = useState(false);
  const [msgAgencyCheck, setMsgAgencyCheck] = useState("");
  const [agencyCheckStatus, setAgencyCheckStatus] = useState(false);
  const [keyReCAPTCHA, setKeyReCAPTCHA] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const { isLoading, isSuccess, isFailure } = useSelector(
    (state) => state.auth
  );

  const GetRole_Data = async () => {
    try {
      const response = await HttpClient.get("/api/users/personal/role/list");

      if (response.status) {
        setRole_Data(response.results);
        return response;
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };
  const envRes = async () => {
    const response = await fetch("/resources/env.json");
    const results = await response.json();
    setKeyReCAPTCHA(results.RE_CAPTCHA_KEY)
  }

  useEffect(() => {
    dispatch(clearLoginAsyncState());
  }, [dispatch]);

  useEffect(() => {
    GetRole_Data();
    envRes()
    return () => setKeyReCAPTCHA('')
  }, []);

  // useEffect(() => {
  //   if (!!queryParams.code && !isLoading && !isFailure && !isSuccess) {
  //     console.log("queryParams ", queryParams);
  //     dispatch(login(queryParams.code, ENV.getConfig().loginRedirectUrl));
  //   }
  // }, [
  //   dispatch,
  //   isFailure,
  //   isLoading,
  //   isSuccess,
  //   queryParams,
  //   queryParams.code,
  // ]);

  useEffect(() => {
    if (!isLoading && isSuccess) {
      dispatch(clearLoginAsyncState());
      history.replace("/");
    }
  }, [isSuccess, isLoading, history, dispatch, isFailure]);

  const validationSchema = yup.object({
    email: yup
      .string()
      .required("Email is required")
      .email("Email is invalid format"),
    password: yup.string().required("Password is required"),
    username: yup.string().required("Username is required"),
    firstname: yup.string().required("Firstname is required"),
    lastname: yup.string().required("Lastname is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      username: "",
      password: "",
      firstname: "",
      lastname: "",
      email: "",
      mobile: "",
      type: "",
      company_code: null,
    },
    isInitialValid: false,
    onSubmit: async (values) => {
      const data = {
        username: values.username,
        Password: values.password,
        Firstname: values.firstname,
        LastName: values.lastname,
        Email: values.email,
        mobile: values.mobile,
        roleId: values.type,
        angecyNo: values.company_code !== "" ? values.company_code : null,
        response: isVerified
      };

      try {
        const response = await HttpClient.post("/api/users/username/check", {
          username: data.username,
        });
        // When Username Checked
        if (response.results.check) {
          try {
            const response_email = await HttpClient.post(
              "/api/users/email/check",
              {
                email: data.Email,
              }
            );
            //When Email Check Success
            if (response_email.results.check) {
              dispatch(Register(data));
            } else {
              const MySwal = withReactContent(Swal);

              MySwal.fire({
                icon: "error",
                didOpen: () => {
                  MySwal.clickConfirm();
                },
              }).then(() => {
                return MySwal.fire(
                  "Email Already !",
                  "Please Change Email !",
                  "error"
                );
              });
            }
            if (response_email.status) return response_email;
            return Promise.reject(response_email);
          } catch (error) {
            const newError = error;
            throw newError;
          }
        } else {
          const MySwal = withReactContent(Swal);

          MySwal.fire({
            icon: "error",
            didOpen: () => {
              MySwal.clickConfirm();
            },
          }).then(() => {
            return MySwal.fire(
              "User Already !",
              "Please Change Username !",
              "error"
            );
          });
        }
        if (response.status) return response;
        return Promise.reject(response);
      } catch (error) {
        const newError = error;
        throw newError;
      }

      // dispatch(Register(data));
    },
  });

  const checkAgencyNo = async (no) => {
    try {
      const response = await HttpClient.get(
        `/api/agency/checkno?angecyNo=${no}`
      );
      if (response.status) {
        console.log(response);
        setMsgAgencyCheck("Company Code Match !");
        setAgencyCheckStatus(true);
        return response;
      } else {
        setMsgAgencyCheck(response.message);
        setAgencyCheckStatus(false);
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };
  const handleRecaptchaVerify = (token) => {
    // const body = {
    //   secret: '',
    //   response: token
    // }
    // const checkVerified = async () => {
    //   try {
    //     const response = await HttpClient.post(
    //       `/api/external/google/recaptcha`, body
    //     );
    //     if (response.status) {
    //       setIsVerified(response.results.success)

    //       return response;
    //     } else {
    //       setMsgAgencyCheck(response.message);
    //       setIsVerified(false)
    //     }
    //     return Promise.reject(response);
    //   } catch (error) {
    //     const newError = error;
    //     throw newError;
    //   }
    // };
    // checkVerified()
    setIsVerified(token)
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className={classes.root}>
        <Container maxWidth="sm" style={{ marginBottom: 20 }}>
          <Card className={classes.paper}>
            <CardContent className={classes.content}>
              <Typography variant="h4" className={classes.title}>
                Register
              </Typography>
              <Typography variant="h6">BOI VISA Service</Typography>
              <div className={classes.line} />
              <img
                alt="smart-visa"
                src="/assets/images/logoBoi.png"
                className={classes.logo}
              />
              <TextField
                label="Username"
                variant="outlined"
                style={{
                  marginTop: 5,

                  borderRadius: "5px",
                }}
                name="username"
                value={formik.values.username}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("username", formik)}
                helperText={getErrorMessage("username", formik)}
              />
              <TextField
                label="Password"
                variant="outlined"
                type="password"
                style={{
                  marginTop: 10,

                  borderRadius: "5px",
                }}
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("password", formik)}
                helperText={getErrorMessage("password", formik)}
              />
              <Grid container style={{ marginTop: 5 }} spacing={1}>
                <Grid container item xs={6} direction="column">
                  <TextField
                    label="Firstname"
                    variant="outlined"
                    style={{
                      borderRadius: "5px",
                    }}
                    name="firstname"
                    value={formik.values.firstname}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("firstname", formik)}
                    helperText={getErrorMessage("firstname", formik)}
                  />
                </Grid>
                <Grid container item xs={6} direction="column">
                  <TextField
                    label="Lastname"
                    variant="outlined"
                    style={{
                      borderRadius: "5px",
                    }}
                    name="lastname"
                    value={formik.values.lastname}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("lastname", formik)}
                    helperText={getErrorMessage("lastname", formik)}
                  />
                </Grid>
              </Grid>
              <TextField
                label="Email"
                variant="outlined"
                style={{
                  marginTop: 5,

                  borderRadius: "5px",
                }}
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("email", formik)}
                helperText={getErrorMessage("email", formik)}
              />
              <Grid container style={{ marginTop: 5 }} spacing={1}>
                <Grid container item xs={6} direction="column">
                  <TextField
                    label="Mobile"
                    variant="outlined"
                    style={{
                      borderRadius: "5px",
                    }}
                    name="mobile"
                    value={formik.values.mobile}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("mobile", formik)}
                    helperText={getErrorMessage("mobile", formik)}
                  />
                </Grid>
                <Grid container item xs={6} direction="column">
                  <FormControl
                    style={{
                      borderRadius: "5px",
                    }}
                    variant="outlined"
                    fullWidth
                  >
                    <InputLabel>User Type</InputLabel>
                    <Select
                      // value={age}
                      // onChange={handleChange}

                      label="User Type"
                      name="type"
                      value={formik.values.type}
                      onChange={(e) => {
                        formik.setFieldValue("type", e.target.value);
                        formik.setFieldValue("company_code", "");
                        setMsgAgencyCheck("");
                        setAgencyCheckStatus(false);
                      }}
                      onBlur={formik.handleBlur}
                    >
                      {roleData.map((data) => (
                        <MenuItem key={data.roleId} value={data.roleId}>
                          {data.roleName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {formik.values.type === "8963170d-3d27-4e2d-a455-fb02e7901c62" ? (
                <Grid
                  container
                  style={{ marginTop: 5, marginBottom: 20 }}
                  spacing={1}
                >
                  <Grid item xs={10}>
                    <TextField
                      label="Company Code"
                      variant="outlined"
                      style={{
                        borderRadius: "5px",
                      }}
                      fullWidth
                      name="company_code"
                      value={formik.values.company_code}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError("company_code", formik)}
                      helperText={getErrorMessage("company_code", formik)}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      style={{ margin: 5 }}
                      disabled={formik.values.company_code === ""}
                      onClick={() => {
                        checkAgencyNo(formik.values.company_code);
                      }}

                    //   href={oneLoginURL}
                    >
                      {isLoading && (
                        <CircularProgress
                          color="secondary"
                          className={classes.loading}
                          size={18}
                        />
                      )}
                      ยืนยัน
                    </Button>
                  </Grid>

                  {!agencyCheckStatus ? (
                    <font color="red">{msgAgencyCheck} </font>
                  ) : (
                    <font color="green">{msgAgencyCheck}</font>
                  )}
                </Grid>
              ) : null}
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  value={checkBox}
                  onChange={() => setCheckbox(!checkBox)}
                  label="I hereby confirm that the information above is true and acknowledge that I will be contacted regarding my Smart Visa / LTR application or my Smart Visa / LTR via the provided contact information."
                />
              </FormGroup>
              {keyReCAPTCHA &&
                <Box sx={{
                  width: '100%', display: "flex", justifyContent: 'center', margin: '10px 0',
                  // '& div > div > div > iframe': {
                  //   display: "block !important"
                  // }

                }}>
                  <ReCAPTCHA
                    sitekey={keyReCAPTCHA || ''}
                    onChange={handleRecaptchaVerify}
                  />
                </Box>}
              {formik.values.type === "8963170d-3d27-4e2d-a455-fb02e7901c62" ? (
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  className={classes.submit}
                  disabled={
                    isLoading ||
                    !formik.isValid ||
                    !checkBox ||
                    !agencyCheckStatus ||
                    !isVerified
                  }
                  type="submit"
                //   href={oneLoginURL}
                >
                  {isLoading && (
                    <CircularProgress
                      color="secondary"
                      className={classes.loading}
                      size={18}
                    />
                  )}
                  Register
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  className={classes.submit}
                  disabled={isLoading || !formik.isValid || !checkBox || !isVerified}
                  type="submit"
                //   href={oneLoginURL}
                >
                  {isLoading && (
                    <CircularProgress
                      color="secondary"
                      className={classes.loading}
                      size={18}
                    />
                  )}
                  Register
                </Button>
              )}

              <Button
                color="secondary"
                size="small"
                className={classes.offlineLogin}
                fullWidth={false}
                disabled={isLoading}
                //   onClick={handleClickOffline}
                to="/login_draft"
                component={Link}
              >
                Back To Login
              </Button>
            </CardContent>
          </Card>
        </Container>
      </div>
    </form>
  );
}
